import type { MainBannerV3Data } from "~/core";

export const isMainBannerV3 = (item: unknown): item is MainBannerV3Data => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "main_banner_v3"
  );
};
